$(function () {
    $('input.datetime').datetimepicker();

    $('input.date').datetimepicker({
        format: 'L'
    });

    $('input.time').datetimepicker({
        format: 'LT'
    });

    $('[data-start-date-id]').on('dp.change', function (e: any) {
        $('[data-end-date-id="' + $(this).data('start-date-id') + '"]').data('DateTimePicker').minDate(e.date);
    });

    $('[data-end-date-id]').on('dp.change', function (e: any) {
        $('[data-start-date-id="' + $(this).data('end-date-id') + '"]').data('DateTimePicker').maxDate(e.date);
    });

    $("div.alert[data-hash]").on("closed.bs.alert", event => {
        $.post("/home/dismiss-alert", {
            hash: $(event.currentTarget).data("hash")
        });
    });

    const $selectorForm = $("#office-selector-form, #search-form");

    function initializeDropdown() {
        if ($selectorForm.length) {
            const $officeSelect = $selectorForm.find("[name='id']");
            const $currentPath = window.location.pathname || '';

            // 1. Read the selectedOfficeId from localStorage and set the dropdown value
            const selectedOfficeId = localStorage.getItem('selectedOfficeId');
            if (selectedOfficeId !== null) {
                // Check if the option exists in the dropdown before setting it
                if ($officeSelect.find(`option[value='${selectedOfficeId}']`).length > 0) {
                    $officeSelect.val(selectedOfficeId);
                } else {
                    console.log(`The selected office with id ${selectedOfficeId} does not exist in the dropdown. Setting it to the default value.`);
                }
            }

            // 2. Update localStorage whenever the dropdown value changes
            $officeSelect.off("change").on("change", function (event) {
                const selectedVal = $(event.delegateTarget).val();

                // Save the selected value to localStorage
                localStorage.setItem('selectedOfficeId', selectedVal?.toString() || '');

                // Only perform actions if the selected value exists in the dropdown
                if ($officeSelect.find(`option[value='${selectedVal}']`).length > 0) {
                    if (selectedVal == "-2") {
                        window.location.assign($selectorForm.data("action-empty"));
                    } else if (selectedVal == "-1") {
                        if ($currentPath !== "/honorcards/create") {
                            window.location.assign($selectorForm.data("action-all"));
                        } else {
                            $selectorForm.submit();
                        }   
                    } else {
                        $selectorForm.submit();
                    }
                }
            });
        }
    }

    // // Initialize dropdown on load
    initializeDropdown();

    // Reinitialize the dropdown whenever the page is shown, including during back/forward navigation
    $(window).on("pageshow", function () {
        initializeDropdown();
    });
});
